import React from 'react';
import { statusMessageEventName } from '@famly/stat_ts-utils_global-messages';
/**
 * Subscribes to the native browser `CustomEvent` emitted by the global message hooks
 * (`useUpdateSuccess`/`useUpdateError`/`useUpdateInfo`) and invokes the provided callback
 * with the message details whenever one is dispatched.
 *
 * This is the bridge that lets the decoupled, redux-free message hooks feed into the
 * redux-backed global event renderer.
 *
 * @param onStatusMessage callback invoked with the message details for each emitted event
 */
export function useStatusMessageEventListener(onStatusMessage) {
    React.useEffect(() => {
        const handleStatusMessage = (event) => {
            onStatusMessage(event.detail);
        };
        window.addEventListener(statusMessageEventName, handleStatusMessage);
        return () => {
            window.removeEventListener(statusMessageEventName, handleStatusMessage);
        };
    }, [onStatusMessage]);
}
